import { createSlice } from '@reduxjs/toolkit';
import { fetchVideoStories, fetchVideoStory } from './operations';
const initialState = {
  storyList: [
    {
      src: 'https://dating-date-video-stories.s3.us-east-2.amazonaws.com/single+ladies.mp4',
      title: 'single ladies',
      id: 7,
    },
    {
      src: 'https://dating-date-video-stories.s3.us-east-2.amazonaws.com/Charming+Caroline.MP4',
      title: 'Charming Caroline',
      id: 6,
    },
    {
      src: 'https://dating-date-video-stories.s3.us-east-2.amazonaws.com/pretty+victoria+27.mp4',
      title: 'Pretty Victoria 27',
      id: 5,
    },
    {
      src: 'https://dating-date-video-stories.s3.us-east-2.amazonaws.com/ukrainian+singles.mp4',
      title: 'Ukrainian Singles',
      id: 4,
    },
    {
      src: 'https://dating-date-video-stories.s3.us-east-2.amazonaws.com/speed+dating.mp4',
      title: 'speed dating',
      id: 3,
    },
    {
      src: 'https://dating-date-video-stories.s3.us-east-2.amazonaws.com/european+singles.mp4',
      title: 'european singles',
      id: 2,
    },

    {
      src: 'https://dating-date-video-stories.s3.us-east-2.amazonaws.com/ukrainian+dating+sites.mp4',
      title: 'ukrainian dating sites',
      id: 1,
    },
  ],

  isLoading: false,
  error: null,
  videoStoryDetail: {},
};

const handlePending = state => {
  state.isLoading = true;
  state.error = null;
};
const handleRejected = (state, { payload }) => {
  state.isLoading = false;
  state.error = payload;
};

export const sliceVideoStories = createSlice({
  name: 'VideoStories',
  initialState,
  reducers: {
    setCurrentStory(state, { payload: userData }) {
      state.videoStoryDetail = state.storyList.find(el => el.id == userData);
    },
  },

  extraReducers: builder => {
    builder
      .addCase(fetchVideoStories.fulfilled, (state, { payload: userData }) => {
        state.isLoading = false;
        state.error = null;
        state.storyList = userData;
      })
      .addCase(fetchVideoStory.fulfilled, (state, { payload: userData }) => {
        state.isLoading = false;
        state.error = null;
        state.videoStoryDetail = userData;
      })
      .addCase(fetchVideoStories.pending, handlePending)
      .addCase(fetchVideoStories.rejected, handleRejected)
      .addCase(fetchVideoStory.pending, handlePending)
      .addCase(fetchVideoStory.rejected, handleRejected);
  },
});

export const { setCurrentStory } = sliceVideoStories.actions;
export default sliceVideoStories.reducer;
